export function loadCircleChart(
  myChart,
  data,
  fontSizes,
  widths,
  itemGaps,
  unit = ""
) {
  myChart.clear();
  if (Array.isArray(data) && data.length > 0) {
    let total = 0;
    data.forEach(ele => {
      total += Number(ele.value);
    });

    myChart.setOption({
      title: [
        {
          show: false,
          text: "面积占比",
          top: "center",
          left: "22%",
          textStyle: {
            color: "#fff",
            fontSize: 12
          }
        }
      ],
      color: [
        "#FE9059",
        "#5C7BD9",
        "#9FE080",
        "#FFDC60",
        "#FF7070",
        "#58D5FF",
        "#EA7CCC"
      ],
      legend: {
        show: true,
        right: "3%",
        itemGap: itemGaps,
        // y: "center",
        top: "14%",
        itemWidth: widths,
        itemHeight: widths,
        orient: "vertical",
        formatter: function(e) {
          let val = data.find(it => {
            return e === it.name;
          });
          const percent = (val.value / total) * 100;
          return e + " (" + percent.toFixed(2) + "%)";
          //return e + ": " + val.value + unit + "(" + percent.toFixed(2) + "%)";
        },
        textStyle: {
          color: "#fff",
          fontSize: fontSizes
        }
      },
      tooltip: {
        trigger: "item",
        formatter: "{b} : {c}" + unit + " ({d}%)"
      },
      series: [
        // 主要展示层的
        {
          radius: ["50%", "80%"],
          center: ["28%", "50%"],
          type: "pie",
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          data: data
        },
        // 边框的设置
        {
          radius: ["40%", "44%"],
          center: ["28%", "50%"],
          type: "pie",
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          labelLine: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          animation: false,
          tooltip: {
            show: false
          },
          data: [
            {
              value: 1,
              itemStyle: {
                color: "rgba(250,250,250,0.3)"
              }
            }
          ]
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
